import React, { useState } from 'react';
import { apiClient } from "../utils/apiClient";
import { Loader2, ShieldCheck, AlertTriangle, Unlock } from 'lucide-react';

export default function UnlockConfirmModal({ user, onClose, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await apiClient(`SecurityAuditLogs/unlock-user/${user.userId}`, {
                method: 'POST'
            });
            onSuccess();
        } catch (err) {
            setError(err.message || 'Kullanıcı kilidi kaldırılırken bir hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/75 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-white dark:bg-[#18191c] rounded-2xl max-w-lg w-full shadow-2xl border border-gray-200 dark:border-gray-800 overflow-hidden">
                <div className="p-5 border-b border-gray-200 dark:border-gray-800 bg-emerald-50/70 dark:bg-emerald-950/25 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center text-emerald-600 dark:text-emerald-400">
                            <ShieldCheck className="w-5 h-5" />
                        </div>
                        <h2 className="text-base font-bold text-gray-900 dark:text-white">
                            Kullanıcı Hesap Kilidini Kaldır
                        </h2>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-700 dark:hover:text-white transition-colors text-xl font-bold"
                    >
                        ✕
                    </button>
                </div>

                <div className="p-5 space-y-4">
                    <div className="p-4 bg-amber-50/80 dark:bg-amber-950/25 border border-amber-200 dark:border-amber-800/50 rounded-xl flex gap-3 text-amber-800 dark:text-amber-200">
                        <AlertTriangle className="w-5 h-5 shrink-0 text-amber-600 dark:text-amber-400 mt-0.5" />
                        <div className="text-xs leading-relaxed">
                            <p className="font-bold mb-1">Güvenlik Onayı</p>
                            <p>
                                <strong>{user.targetFullName || user.targetUsername || `#${user.userId}`}</strong>
                                {user.targetFullName && user.targetUsername && user.targetFullName !== user.targetUsername
                                    ? ` (${user.targetUsername})`
                                    : ''}{' '}
                                kullanıcısının hatalı şifre denemeleri nedeniyle oluşan geçici hesap kilidini kaldırmak üzeresiniz.
                                Bu işlem <strong>Güvenlik Denetim Logları</strong> tablosuna sizin adınızla kaydedilecektir.
                            </p>
                        </div>
                    </div>

                    {error && (
                        <div className="bg-rose-50 dark:bg-rose-950/30 text-rose-700 dark:text-rose-300 p-3.5 rounded-xl text-xs font-medium border border-rose-200 dark:border-rose-800/50 break-words">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="flex justify-end gap-2.5 pt-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-xs font-semibold text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-[#111214] border border-gray-200 dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-xl transition-colors"
                        >
                            Vazgeç
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-semibold bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl shadow-sm transition-colors disabled:opacity-50"
                        >
                            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Unlock className="w-4 h-4" />}
                            {loading ? 'Kilit Açılıyor...' : 'Kilidi Kaldır ve Logla'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
